import { useMemo } from 'react'

import { useApiClient } from 'clients/yogi-api'
import { AskYogiService } from 'features/ask-yogi/service/service'

export { AskYogiService } from 'features/ask-yogi/service/service'
export type {
  AskYogiCapability,
  AskYogiConnector,
  AskYogiConnectorState,
  AskYogiConnectorStateDto,
  AskYogiConnectorStatus,
  HubMember,
  PromptShare,
  PromptShareDto,
  SavedPrompt,
  SavedPromptDto,
  SavedPromptPermission,
  SendMessageRequestBody,
  SkillContext,
} from 'features/ask-yogi/service/types'
export {
  ASK_YOGI_CONNECTORS_QUERY_KEY,
  CONVERSATIONS_QUERY_KEY,
  deriveConnectorsEnabled,
  deriveRequestCapabilities,
  deriveRequestConnectors,
  PROMPT_SHARES_QUERY_KEY,
  SAVED_PROMPTS_QUERY_KEY,
  STARTER_QUESTIONS_QUERY_KEY,
  toAskYogiConnectorState,
  toHubMember,
  toPromptShare,
  toSavedPrompt,
} from 'features/ask-yogi/service/types'

export function useAskYogiService(): AskYogiService {
  const client = useApiClient()
  return useMemo(() => new AskYogiService(client), [client])
}
